import { render, staticRenderFns } from "./ModalitySelect.vue?vue&type=template&id=62574a83"
import script from "./ModalitySelect.vue?vue&type=script&lang=js"
export * from "./ModalitySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports